import { config as i18nConfig } from './i18n-config';
import { config as communicationConfig } from './communication-config';
import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/onboarding';

const arqConfig: iFacadeConfig = {
	communicationConfig,
	i18nConfig,
	authConfig: {
		enableAuth: true,
	},
};

export { arqConfig };
